import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_ResolvableServiceUsage_Create_Mutation =
  graphql(`
    mutation MissionServicesInfoForm_ResolvableServiceUsage_Create(
      $serviceUsage: ResolvableServiceUsageInput!
      $serviceUserId: Id!
      $serviceUsagesGroupId: Id!
      $versionData: VersionDataInput
    ) {
      createMissionServiceUsage(
        serviceUsage: $serviceUsage
        serviceUserId: $serviceUserId
        serviceUsagesGroupId: $serviceUsagesGroupId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useCreateMissionResolvableServiceUsageMutation = () =>
  useGraphQLMutation(
    MissionServicesInfoForm_ResolvableServiceUsage_Create_Mutation,
  );
